// extracted by mini-css-extract-plugin
export default {"topbar":"TopBar_topbar__vzKpy","brasslogo":"TopBar_brasslogo__FQAE0","helpdesk":"TopBar_helpdesk__EsmrL"};